export const DecoClassName = 'pm-command-input';
